import ApartmentIcon from '@mui/icons-material/Apartment';
import { Box, Typography } from '@mui/material';
import React from 'react';
import FundOpportunity from '../../../models/FundOpportunity';
import AvailableFundCard from './AvailableFundCard';
import SectionCard from './SectionCard';

export default function NewFundOpportunitiesSection({
  availableFunds,
  fundsLoading,
  investedFundIds,
  newFunds,
  navigate,
}: {
  availableFunds: FundOpportunity[];
  fundsLoading: boolean;
  investedFundIds: Set<string>;
  newFunds: FundOpportunity[];
  navigate: (path: string) => void;
}) {
  return (
    <SectionCard
      title="New Fund Opportunities"
      icon={<ApartmentIcon sx={{ fontSize: 18, color: 'text.secondary' }} />}
      loading={fundsLoading}
    >
      {!fundsLoading && newFunds.length === 0 && availableFunds.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No funds currently open for EOI.
        </Typography>
      )}
      {!fundsLoading && newFunds.length === 0 && availableFunds.length > 0 && (
        <Typography variant="body2" color="text.secondary">
          This investor has already registered interest in all available funds.
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {newFunds.map((fund) => (
          <AvailableFundCard key={fund.id} fund={fund} navigate={navigate} />
        ))}
      </Box>

      {investedFundIds.size > 0 && availableFunds.some((f) => investedFundIds.has(f.id)) && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mb: 1 }}>
            Already has an expression of interest in:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {availableFunds
              .filter((f) => investedFundIds.has(f.id))
              .map((fund) => (
                <AvailableFundCard key={fund.id} fund={fund} navigate={navigate} />
              ))}
          </Box>
        </Box>
      )}
    </SectionCard>
  );
}
